export enum PrecificacaoComplemento {
    "Somar" = "soma",
    "Preço dividido" = "precoDividido",
    "Maior preço" = "maiorPreco"
}
